/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSelectedImage, setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Image from 'material/embeds/imageapi/imagepane/image/image';



/* ========== ~~~~~~~~~~ IMAGE PANE : IMAGE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({embedsState}) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Image);
